export default [
  {
    id: 'default',
    label: 'Regelbesteuert'
  },
  {
    id: 'differential',
    label: 'Differenzbesteuert'
  }
]
